import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { defaultOption } from './data.js';
export class WordSpacePlugin {
    constructor(opt) {
        this.name = 'wordSpace';
        this.spec = {
            type: 'mark',
            matchStyle: {
                'letter-spacing': (space) => (space ? { space } : false),
            },
            attrs: {
                space: {
                    toDOMAttribute: (space) => space ? { style: `letter-spacing: ${space}` } : null,
                },
            },
            toDOM: 'span',
        };
        this.set = (space) => {
            if (space) {
                this.editor.selection().addMark(this, { space });
            }
            else {
                this.editor.selection().removeMark(this);
            }
        };
        this.get = () => this.editor.selection().getMarkAttrs(this).space;
        this.canApply = () => this.editor.selection().canToggleMark(this);
        this.opt = {
            ...defaultOption,
            ...opt,
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                get: this.get,
            },
        };
    }
    renderToolbarItem() {
        const t = this.editor.t.bind(this.editor);
        const select = document.createElement('exeditor-toolbar-select');
        select.label = t('字间距');
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.wordSpaceIcon),
        });
        select.appendChild(icon);
        this.opt.options.forEach((entry) => {
            const option = document.createElement('exeditor-toolbar-option');
            option.slot = 'option';
            option.value = entry.value;
            option.textContent = entry.label;
            option.onclick = () => {
                this.editor.focus();
                this.set(entry.value);
            };
            select.appendChild(option);
        });
        const setBtnProps = () => {
            const space = this.get();
            select.active = Boolean(space);
            select.value = space || this.opt.default;
            select.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return select;
    }
}
//# sourceMappingURL=index.js.map